// Components/Reservation/ExceptionSlotItem.jsx
import React from "react";
import { IconButton } from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";

const ExceptionSlotItem = ({ slot, onRestore }) => {
  return (
    <div className="col-6 col-md-4 col-lg-3">
      <div
        className="p-3 text-center position-relative"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "12px",
          border: "2px solid #5a67d8",
          cursor: "pointer",
          transition: "all 0.3s ease",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
        }}
      >
        <div
          className="position-absolute top-0 start-0 px-2 py-1"
          style={{
            background: "rgba(239, 68, 68, 0.9)",
            borderRadius: "12px 0 8px 0",
            fontSize: "0.7rem",
            color: "white",
            fontWeight: "bold",
          }}
        >
          حذف شده
        </div>

        <div className="d-flex flex-column align-items-center pt-3">
          <span
            className="iran-sans fw-bold"
            style={{
              fontSize: "1.2rem",
              color: "white",
              textShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            {slot.startTime}
          </span>

          <IconButton
            onClick={() => onRestore(slot.id)}
            size="small"
            className="mt-2"
            sx={{
              color: "white",
              background: "rgba(255, 255, 255, 0.2)",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.3)",
                transform: "scale(1.1)",
              },
              transition: "all 0.2s ease",
            }}
          >
            <RestoreIcon fontSize="small" />
          </IconButton>
          <span
            className="iran-sans mt-1"
            style={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.9)" }}
          >
            بازگردانی
          </span>
        </div>
      </div>
    </div>
  );
};

export default ExceptionSlotItem;
